import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCodeBrackets: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCodeBrackets"><Path fillRule="evenodd" clipRule="evenodd" d="M15.2128 3.27236L10.7278 21.2127L8.78747 20.7276L13.2725 2.78729L15.2128 3.27236ZM7.41436 8.00001L3.41436 12L7.41436 16L6.00015 17.4142L0.585938 12L6.00015 6.5858L7.41436 8.00001ZM18.0002 6.5858L23.4144 12L18.0002 17.4142L16.5859 16L20.5859 12L16.5859 8.00001L18.0002 6.5858Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCodeBrackets;
